import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useSeo } from "@/hooks/useSeo";
import { MaskedLines } from "@/components/motion/Reveal";

export default function NotFound() {
  useSeo({ title: "Page not found", description: "The page you were looking for could not be found.", path: "/404", noindex: true });
  return (
    <section data-testid="not-found" className="flex min-h-screen items-center bg-bone">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-8 md:px-10 lg:px-12 xl:px-16">
        <p className="mb-6 text-xs font-bold uppercase tracking-[0.22em] text-accent">Error 404</p>
        <MaskedLines
          lines={["Nothing", "here."]}
          className="font-display text-[22vw] font-extrabold leading-[0.85] tracking-tighter text-ink md:text-[12vw]"
        />
        <p className="mt-8 max-w-md text-lg text-muted">
          The page you were looking for has moved or never existed. Let's get you back to the work.
        </p>
        <Link
          to="/"
          data-testid="notfound-home"
          className="mt-8 inline-flex items-center gap-2 border border-ink px-6 py-4 text-sm font-bold uppercase tracking-[0.14em] text-ink transition-colors hover:bg-ink hover:text-bone"
        >
          <ArrowLeft size={16} /> Back home
        </Link>
      </div>
    </section>
  );
}
